export default {
    props: {
        sortDir: {
            type: String,
            default: undefined,
            kComposite: 'sort.dir'
        },
        sortField: {
            type: String,
            default: undefined,
            kComposite: 'sort.field'
        },
        sortCompare: {
            type: Function,
            default: undefined,
            kComposite: 'sort.compare'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/Sort.js